import {
  NavItemExternalLink,
  NavItemInternalLink,
} from '@/domain/navigation/features/navigation/components/MobileNavItem/NavItem';
import { useDesignSettings } from '@/domain/termine/hooks/useDesignSettings';
import { useProfile } from '@/hooks';
import { buildLink } from '@/utils';
import { useTranslation } from 'react-i18next';

export function useMoreSubmenuItems({
  handleClose,
}: {
  handleClose: () => void;
}) {
  const { t } = useTranslation();
  const profile = useProfile();
  const manager = profile.manager;
  const { managerSettings } = useDesignSettings();
  const designAuswahl = managerSettings?.designSettings.seitenImV2Design;
  const menuItems = [];

  if (manager.rechte.konflikte) {
    menuItems.push(
      <NavItemExternalLink href={buildLink('konflikte')}>
        {t('entities.conflict_other')}
      </NavItemExternalLink>,
    );
  }
  if (manager.rechte.termine) {
    if (designAuswahl && designAuswahl.includes('TERMINE')) {
      const currentDate = new Date();
      const termineLink = `/termine/uebersicht/${currentDate.getFullYear()}/${(currentDate.getMonth() + 1).toString().padStart(2, '0')}`;
      menuItems.push(
        <NavItemInternalLink to={termineLink} onClick={handleClose}>
          {t('entities.event_other')}
        </NavItemInternalLink>,
      );
    } else {
      menuItems.push(
        <NavItemExternalLink key="termine" href={buildLink('termine')}>
          {t('entities.event_other')}
        </NavItemExternalLink>,
      );
    }
  }

  if (manager.rechte.mitarbeiter.dokumente) {
    menuItems.push(
      <NavItemExternalLink href={buildLink('dokumente')}>
        {t('entities.document_other')}
      </NavItemExternalLink>,
    );
  }

  if (manager.rechte.neuigkeiten) {
    menuItems.push(
      <NavItemExternalLink href={buildLink('neuigkeiten')}>
        {t('entities.neuigkeiten')}
      </NavItemExternalLink>,
    );
  }

  return menuItems;
}
